module.exports = __webpack_public_path__ + "static/media/logoIn.f9b722a1.svg";